import type { I18N } from '@vista-digital/i18n'
import type { Site } from '@vista-digital/ocapi-types/v1'
import { getItemById } from '@vista-digital/occ-domain'
import type { ConcessionLine } from '../types/ecommerce/fnb.gtm'
import { getConcessionEcommerceItem } from './getConcessionEcommerceItem'
import { EcommerceFnbItem } from '../models-gtm'

export const getConcessionCartItems = (concessions: ConcessionLine[], site: Site, i18n: I18N): EcommerceFnbItem[] => {
    const ecommerceItems = new Array<EcommerceFnbItem>()

    for (const concessionLine of concessions) {
        const id = 'itemId' in concessionLine ? concessionLine.itemId : concessionLine.id
        const price = 'price' in concessionLine ? concessionLine.price.valueIncludingTax : undefined
        const concessionItem = getItemById(id)

        if (!concessionItem) continue

        const item = getConcessionEcommerceItem(concessionItem, site, i18n)
        item.quantity = 1
        item.price = price
        ecommerceItems.push(item)
    }
    return ecommerceItems
}
